<template>
  <div>
    <tiles :wrap="true">
      <div
        v-for="(obj,name) in config.data"
        :key="name"
        class="tile is-parent is-3">
        <tile-action-data-config
          v-if="mapping[name]"
          :title="`${mapping[name].label}`"
          :config="obj"
          :def="mapping[name]">
        </tile-action-data-config>
      </div>
    </tiles>
  </div>
</template>

<script>
import TileActionDataConfig from '@/components/actions/tiles/TileActionDataConfig.vue';
import Tiles from '@/components/Tiles.vue';

export default {
  name: 'DataConfigs',
  components: { TileActionDataConfig, Tiles },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defs: this.$typeDefs,
      mapping: {
        fsEvent: this.$typeDefs.events.GPFSEvent,
        procEvent: this.$typeDefs.events.GPProcessEvent,
        screenshotEvent: this.$typeDefs.events.GPScreenshotEvent,
        clickEvent: this.$typeDefs.events.GPClickEvent,
        downloadEvent: this.$typeDefs.events.GPDownloadEvent,
        usbEvent: this.$typeDefs.events.GPUSBEvent,
        file: this.$typeDefs.types.file,
        process: this.$typeDefs.types.process,
        user: this.$typeDefs.types.user,
        group: this.$typeDefs.types.group,
        binary: this.$typeDefs.types.binary,
      },
    };
  },
};
</script>
